import React from 'react';

import { connect } from 'react-redux';

import { BobTVUser } from '../BobTVUser';

import UserContextMenu from '../UserContextMenu/index';
import UserContextMenuItem from '../UserContextMenuItem/index';

import Registry from '../../../registry/index';

export class PmWindowContextMenu extends UserContextMenu {
    constructor(props) {
        super(props);

        this.afterClosePositionReset = false;
        if (props.browser && props.browser.tablet) this.userClosable = false;

        UserContextMenu.registerPopupInstance(PmWindowContextMenu.generateKey(props), this);
    }

    componentWillUnmount() {
        UserContextMenu.unregisterPopupInstance(PmWindowContextMenu.generateKey(this.props));
    }

    /**
     *  sic! name of method is changed not to conflict with Popup.close() method
     *  @see Popup
     */
    closePm() {
        this.props.hideFn();
    }

    render() {
        let lang = Registry.get('locale');

        let {user, currentUser, currentRoom, userStatusClasses, genderClass} = this.props;
        
        if (!(user instanceof BobTVUser)) {
            user = new BobTVUser(user);
        }

        let allItemsBase = super.getAllItems(lang, user, currentRoom);
        let allItems = {
            view: allItemsBase['view'],
            profile: allItemsBase['profile'],
            follow: allItemsBase['follow'],
            unfollow: allItemsBase['unfollow'],
            virtual_gift: allItemsBase['virtual_gift'],
            give_xxl: allItemsBase['give_xxl'],
            block: allItemsBase['block'],
            unblock: allItemsBase['unblock'],
            ban: allItemsBase['ban'],
            revoke: allItemsBase['revoke'],
            deleteHistory: allItemsBase['deleteHistory'],
            closePm: {onClick: (event) => this.action(event, 'closePm'), label: lang.close_pm},
        };

        let availableItems = [];

        for (let action in allItems) {
            let item = allItems[action];
            let disabled = !super.itemEnabled(action, user, currentUser);

            if (super.itemVisible(action, user, currentUser)) {
                availableItems.push(<UserContextMenuItem key={action} {...item} disabled={disabled}/>);
            }
        }

        let className = 'popup block-pm-context-menu ' + this.state.visibility;

        return (
            <div className={className} ref={(popup) => this._ref = popup}>
                <p className="name">
                    <span className={'user-type-icon ' + genderClass}/> <a>{user.nick}</a>
                </p>

                <div className={userStatusClasses.join(' ')}>
                    {lang.info_age} <span className="age">{user.age}</span>
                    <div className="user-status-icons icon-move">
                        <span className="vol"/>
                        <span className="eye"/>
                        <span className="video"/>
                    </div>
                </div>

                <ul>
                    {availableItems}
                </ul>
            </div>
        )
    }

}

PmWindowContextMenu.generateKey = function(props) {
    return 'pm-window-context-menu-'+props.user.nick;
};


export default connect(null, null, null, {forwardRef: true})(PmWindowContextMenu);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmWindowContextMenu/index.js